// src/pages/MaintenancePage.js
import React from "react";

const MaintenancePage = () => {
  return (
    <div style={styles.body}>
      <article style={styles.article}>
        <h1 style={styles.heading}>We&rsquo;ll be back soon!</h1>
        <div>
          <p>
            Sorry for the inconvenience but we&rsquo;re performing some maintenance at the moment.
            If you need to you can always contact us, otherwise we&rsquo;ll be back online shortly!
          </p>
          <p>&mdash; The Team</p>
        </div>
      </article>
    </div>
  );
};

const styles = {
  body: {
    textAlign: "center",
    padding: "150px",
    font: "20px Helvetica, sans-serif",
    color: "#333",
  },
  article: {
    display: "block",
    textAlign: "left",
    width: "650px",
    margin: "0 auto",
  },
  heading: {
    fontSize: "50px",
  },
};

export default MaintenancePage;